import { useSites } from '../../../context/SiteContext';
import { useReportVisits } from '../../../hooks/useReportVisits';
import { buildReferrers } from '../../../lib/analytics';
import { formatNumber } from '../../../lib/format';
import EmptyState from '../../../components/dashboard/EmptyState';
import PageHeader from '../../../components/dashboard/PageHeader';
import StatTable from '../../../components/dashboard/StatTable';
import ExportButton from '../../../components/dashboard/ExportButton';

export default function ReferrersPage() {
  const { currentSite } = useSites();
  const { ranged, range } = useReportVisits(currentSite);
  const refs = buildReferrers(ranged);
  const total = refs.reduce((sum, r) => sum + r.value, 0);
  const columns = ['来源域名', '浏览量', '占比'];
  const rows = refs.map((r) => [
    r.name,
    formatNumber(r.value),
    total ? `${((r.value / total) * 100).toFixed(1)}%` : '0%',
  ]);

  if (!currentSite) {
    return <EmptyState title="先添加一个站点" desc="添加站点后可统计外部链接带来的流量。" />;
  }

  return (
    <div>
      <PageHeader
        title="外部链接"
        desc="其他网站把访客带到你这里的来源域名排行。"
        range={range}
        extra={<ExportButton filename={`${currentSite.domain}-referrers.csv`} columns={columns} rows={rows} />}
      />
      <div className="mt-6 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
        <StatTable columns={columns} rows={rows} empty="当前时段暂无外链来源，多为直接访问或搜索引擎。" />
      </div>
    </div>
  );
}
